import { apiCall } from './gqlClient';
const GETPROVIDERINVITATIONFLOWS_QUERY = "\n  query getProviderInvitationFlows {\n    getProviderInvitationFlows\n  }";
export const getProviderInvitationFlowsApiCall = async () => apiCall({
  query: GETPROVIDERINVITATIONFLOWS_QUERY,
  variables: {}
});
const GETPROVIDERCUSTOMERSINVITATIONFLOWS_QUERY = "\n  query getProviderCustomersInvitationFlows {\n    getProviderCustomersInvitationFlows\n  }";
export const getProviderCustomersInvitationFlowsApiCall = async () => apiCall({
  query: GETPROVIDERCUSTOMERSINVITATIONFLOWS_QUERY,
  variables: {}
});
const UPDATECUSTOMERFLOWOWNERSTATUS_QUERY = "\n  mutation updateCustomerFlowOwnerStatus($customerFlowId: String!, $status: String!, $rejectionType: String, $rejectionReason: String) {\n    updateCustomerFlowOwnerStatus(customerFlowId: $customerFlowId, status: $status, rejectionType: $rejectionType, rejectionReason: $rejectionReason)\n  }";
export const updateCustomerFlowOwnerStatusApiCall = async _ref => {
  let {
    customerFlowId,
    status,
    rejectionType,
    rejectionReason
  } = _ref;
  return apiCall({
    query: UPDATECUSTOMERFLOWOWNERSTATUS_QUERY,
    variables: {
      customerFlowId,
      status,
      rejectionType,
      rejectionReason
    }
  });
};
const CREATEINVITATIONFLOW_QUERY = "\n  mutation createInvitationFlow($request: JSON!) {\n    createInvitationFlow(request: $request)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const createInvitationFlowApiCall = async function (_ref2) {
  let {
    request
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEINVITATIONFLOW_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEINVITATIONFLOW_QUERY = "\n  mutation updateInvitationFlow($request: JSON!) {\n    updateInvitationFlow(request: $request)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const updateInvitationFlowApiCall = async function (_ref3) {
  let {
    request
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEINVITATIONFLOW_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const SETDEFAULTINVITATIONFLOW_QUERY = "\n  mutation setDefaultInvitationFlow($id: String!) {\n    setDefaultInvitationFlow(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const setDefaultInvitationFlowApiCall = async function (_ref4) {
  let {
    id
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SETDEFAULTINVITATIONFLOW_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const REMOVEDEFAULTINVITATIONFLOW_QUERY = "\n  mutation removeDefaultInvitationFlow {\n    removeDefaultInvitationFlow\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const removeDefaultInvitationFlowApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: REMOVEDEFAULTINVITATIONFLOW_QUERY,
    variables: {},
    fragments
  });
};
const ARCHIVEINVITATIONFLOW_QUERY = "\n  mutation archiveInvitationFlow($id: String!) {\n    archiveInvitationFlow(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const archiveInvitationFlowApiCall = async function (_ref5) {
  let {
    id
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVEINVITATIONFLOW_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETFLOWSIGNATUREUPLOADURL_QUERY = "\n  mutation getFlowSignatureUploadUrl($request: FlowSignatureUploadUrlInput!) {\n    getFlowSignatureUploadUrl(request: $request)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrl\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const getFlowSignatureUploadUrlApiCall = async function (_ref6) {
  let {
    request
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETFLOWSIGNATUREUPLOADURL_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATECUSTOMERDATAFROMINVITATIONFLOW_QUERY = "\n  mutation updateCustomerDataFromInvitationFlow($request: CustomerDataFromFlowInput!) {\n    updateCustomerDataFromInvitationFlow(request: $request)\n    {\n      id\n\t\t\tcopyId\n\t\t\tpresignedUrls\n\t\t\tsignedUrl\n\t\t\tsuccess\n\t\t\tname\n\t\t\tsectionIndex\n\t\t\ttype\n\t\t\tsignatureFileId\n      ...fragments\n    }\n  }";
export const updateCustomerDataFromInvitationFlowApiCall = async function (_ref7) {
  let {
    request
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATECUSTOMERDATAFROMINVITATIONFLOW_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const SENDINVITATIONFLOW_QUERY = "\n  mutation sendInvitationFlow($userId: Int!, $flowId: String!) {\n    sendInvitationFlow(userId: $userId, flowId: $flowId)\n  }";
export const sendInvitationFlowApiCall = async _ref8 => {
  let {
    userId,
    flowId
  } = _ref8;
  return apiCall({
    query: SENDINVITATIONFLOW_QUERY,
    variables: {
      userId,
      flowId
    }
  });
};